import { UUID } from "crypto";

export type PhotoUploadFormData = {
  OrderAttachments: FileList[];
  AccountName: string;
  ShopName: string;
  OrderNo: string;
  TokenId: UUID;
  PONumber: string;
};

export type PhotoUploadPayload = {
  OrderAttachments: FileList[];
  UserName?: string;
  UserID?: number;
  EmailReceivedDateTime?: Date;
  TokenId: string;
  OrderId: number;
  message?: string;
  error?: string;
  success?: string;
};

export type ValidateTokenPayload = {
  token: string;
  message?: string;
  error?: string;
  success?: string;
};

export interface FileList {
  fileName: string;
  orderAttachmentID: number;
  attachment: File;
  isEmailContent: boolean;
  isActive: boolean;
}


export interface UploadState {
  files: FileList[];
  duplicates: FileList[];
  invalids: FileList[];
  error: string | null;
}

export type UploadAction =
  | { type: "ADD_FILES"; payload: FileList[] }
  | { type: "REMOVE_FILE"; payload: FileList }
  | { type: "SET_FILES"; payload: FileList[] }
  | { type: "RESET_ERROR" }
  | {
      type: "UPDATE_FILE_CLARITY";
      payload: {
        fileName: string;
        size: number;
        imageQuality: "G" | "B" | "N";
      };
    };


interface IPhotoUploadState {
  validateTokenData: any; // contains { data: { pagingMetadata, ppciList } }
  photoUploadData: any;
  loading: boolean;
  success: boolean;
  error: string | null;
}

export const PhotoUploadDefaultValue: PhotoUploadPayload = {
  OrderAttachments: [],
  UserName: "",
  UserID:0,
  EmailReceivedDateTime: new Date(),
  TokenId: "",
  OrderId: 0,
  message: undefined,
  error: undefined,
};

export const ValidateTokenDefaultValue: ValidateTokenPayload = {
  token: "",
  message: undefined,
  error: undefined,
};

export const initialState: IPhotoUploadState = {
  validateTokenData: ValidateTokenDefaultValue,
  photoUploadData: PhotoUploadDefaultValue,
  loading: false,
  success: false,
  error: null,
};

export type PhotoUploadServiceOperators = {
  photoUpload: PhotoUploadPayload;
  submitPhotoUpload: (data: PhotoUploadPayload) => void;
};

export type ValidateTokenServiceOperators = {
  validateToken: ValidateTokenPayload;
  submitValidateToken: (data: ValidateTokenPayload) => void;
};
